import { render } from "./Preview2D.vue?vue&type=template&id=57a9bab8"
import script from "./Preview2D.vue?vue&type=script&lang=js"
export * from "./Preview2D.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__